import { all } from 'redux-saga/effects'
import {
  loginSagaWatcher,
  logoutSagaWatcher,
  deleteSagaWatcher,
  verifyChangePasswordWatcher,
  sendForgotEmailSagaWatcher,
  refreshSagaWatcher,
  currentUserInfoSagaWatcher,
} from './authentication'

import {
  userChangePasswordPutWatcher,
  userPasswordSetWatcher,
  userRenewPasswordWatcher,
} from './user-password'
import { shopGetWatcher, shopEditWatcher, shopPatchWatcher } from './shop'
import {
  mediaImageUploadWatcher,
  mediaImageDeleteWatcher,
  openaiGenerateImageWatcher,
  mediaCardImageCreationWatcher,
} from './media-image'
import { mediaVideoUploadWatcher, mediaVideoDeleteWatcher } from './media-video'
import {
  mediaFolderAddAsyncWatcher,
  mediaFolderPatchWatcher,
  mediaFolderDeleteWatcher,
} from './media-folder'

import {
  userAddWatcher,
  userPatchWatcher,
  adminPatchWatcher,
  userGetWatcher,
  userValidateShortLinkWatcher,
  userGetSelfWatcher,
  userListWatcher,
  userIdListWatcher,
} from './user'

import {
  cardAddWatcher,
  cardPatchWatcher,
  cardLinkDeleteWatcher,
  cardMediaAddWatcher,
  cardMediaDeleteWatcher,
  cardSelectionAddWatcher,
  cardSelectionDeleteWatcher,
  cardSelectionPatchWatcher,
  paymentPatchWatcher,
  paymentDisconnectWatcher,
  cardSettingsPatchWatcher,
  cardSettingsCreateWatcher,
  cardSettingsRemoveWatcher,
  getBadgesWatcher,
  courseRemoveCardWatcher,
  courseCardLinkPatchWatcher,
  selectionDeleteWatcher,
  getCardWatcher,
} from './card'

import {
  sendConfirmEmailSagaWatcher,
  confirmCodeSagaWatcher,
  signUpSagaWatcher,
  signUpRootieSagaWatcher,
  appSumosignUpSagaWatcher,
} from './sign-up'
import {
  mediaDirectoryGetRootWatcher,
  mediaDirectoryGetWatcher,
} from './media-directory'

import {
  courseListWatcher,
  courseGetWatcher,
  courseAddWatcher,
  courseEditWatcher,
  courseUpdateWatcher,
  coursePatchWatcher,
  courseReportWatcher,
  courseSettingsCreateWatcher,
  courseSettingsPatchWatcher,
  openAiCardRequestWatcher,
  openAiCourseCreationGetTitleRequestWatcher,
  openAiCourseCreationGetOutlineRequestWatcher,
  openaiSendCourseCreationRequestWatcher,
  templateCourseCloneWatcher,
  sendCreatePromptFromCardContentRequestWatcher,
  getCourseAnalyticsByIdWatcher,
  generateQuizzesByCourseIdWatcher,
  exportCourseToScormWatcher,
  courseCreationProgressWatcher,
  editSectionOrderWatcher,
  sectionPatchWatcher,
  addSectionWatcher,
  createCourseWatcher,
  courseGetByIdWatcher,
  generateCardWatcher,
  aiInstructionWatcher,
  getCourseLandingPageWatcher,
  landingPageWatcher,
  courseFilterWatcher,
} from './course'

import {
  domainListWatcher,
  domainDeleteWatcher,
  domainRetryWatcher,
  domainPatchWatcher,
  domainAddWatcher,
} from './domain'

import {
  courseTimeSeriesListWatcher,
  courseTimeSeriesReportWatcher,
} from './course-time-series'

import {
  courseStatisticsListWatcher,
  courseStatisticsReportWatcher,
} from './course-statistics'

import { appsumoCodeVerifierSagaWatcher } from './appsumo-code'

import { appsumoCodeRefundSagaWatcher } from './appsumo-refund-code'

import {
  userRoleDetailedListWatcher,
  setUserRoleWatcher,
} from './user-role-detailed-list'

import {
  createCourseCollectionSagaWatcher,
  deleteCourseCollectionWatcher,
  courseCollectionListWatcher,
  courseCollectionUpdateWatcher,
  courseCollectionPatchWatcher,
  getCollectionAnalyticsWatcher,
  courseCollectionAnalyticsDownloadWatcher,
} from './course-collection'

import {
  teamsListWatcher,
  teamAddWatcher,
  patchTeamWatcher,
  deleteTeamWatcher,
  teamsMemberListWatcher,
  teamsMemberDeleteWatcher,
  patchTeamMemberWatcher,
  addTeamsMemberWatcher,
  teamsMemberExportWatcher,
  teamsImportMemberWatcher,
  sendMailToLearnerWatcher,
  collectionMemberFilterWatcher,
} from './teams'

import {
  getChatsWatcher,
  sendChatMessageWatcher,
  getChatMessagesWatcher,
  updateChatMessageWatcher,
  uploadAttachmentWatcher,
  checkAttachmentStatusWatcher,
  deleteAttachmentWatcher,
  finalToolWatcher,
  getTranslatedChatContentWatcher,
} from './llm'
import {
  createCertificateSagaWatcher,
  getCertificateSagaWatcher,
  getCertificateListSagaWatcher,
  patchCertificateWatcher,
} from './certificate'

import {
  aICreatorUpdateOutlineWatcher,
  aICreatorUploadAttachmentWatcher,
  aICreatorCheckAttachmentStatusWatcher,
  aICreatorDeleteAttachmentWatcher,
  aICreatorGenerateOutlineWatcher,
  aICreatorGenerateCourseWatcher,
  aICreatorGetRecentAttachmentsWatcher,
  getDocumentHeadersWatcher,
  getAttachmentTitlesWatcher,
} from './ai-creator'

import {
  collectionListWatcher,
  createCollectionWatcher,
  getCollectionWatcher,
  deleteCollectionWatcher,
  getCollectionCourseListWatcher,
  courseDeleteWatcher,
  editCourseCollectionIndexWatcher,
  courseCloneWatcher,
  getCollectionSettingsWatcher,
  patchCollectionSettingWatcher,
  patchCourseCollectionWatcher,
  getCollectionLandingPageWatcher,
  landingPageCollectionWatcher,
} from './collection'

/**
 *
 */
export default function* rootSaga() {
  yield all([
    loginSagaWatcher(),
    logoutSagaWatcher(),
    deleteSagaWatcher(),
    verifyChangePasswordWatcher(),
    sendForgotEmailSagaWatcher(),
    refreshSagaWatcher(),
    currentUserInfoSagaWatcher(),

    userChangePasswordPutWatcher(),
    userPasswordSetWatcher(),
    userRenewPasswordWatcher(),

    userAddWatcher(),
    userPatchWatcher(),
    adminPatchWatcher(),
    userGetWatcher(),
    userValidateShortLinkWatcher(),
    userGetSelfWatcher(),
    userListWatcher(),
    userIdListWatcher(),

    cardAddWatcher(),
    cardPatchWatcher(),
    cardLinkDeleteWatcher(),
    cardSelectionAddWatcher(),
    cardSelectionDeleteWatcher(),
    cardMediaAddWatcher(),
    cardMediaDeleteWatcher(),
    cardSelectionPatchWatcher(),
    paymentPatchWatcher(),
    paymentDisconnectWatcher(),
    cardSettingsPatchWatcher(),
    cardSettingsCreateWatcher(),
    cardSettingsRemoveWatcher(),
    getBadgesWatcher(),
    courseRemoveCardWatcher(),
    editSectionOrderWatcher(),
    selectionDeleteWatcher(),
    getCardWatcher(),

    sendConfirmEmailSagaWatcher(),
    confirmCodeSagaWatcher(),
    signUpSagaWatcher(),
    signUpRootieSagaWatcher(),
    appSumosignUpSagaWatcher(),

    mediaDirectoryGetRootWatcher(),
    mediaDirectoryGetWatcher(),

    mediaImageUploadWatcher(),
    mediaImageDeleteWatcher(),
    mediaVideoUploadWatcher(),
    mediaVideoDeleteWatcher(),
    mediaFolderAddAsyncWatcher(),
    mediaFolderPatchWatcher(),
    mediaFolderDeleteWatcher(),
    openaiGenerateImageWatcher(),
    mediaCardImageCreationWatcher(),

    shopGetWatcher(),
    shopEditWatcher(),
    shopPatchWatcher(),

    courseListWatcher(),
    courseGetWatcher(),
    courseAddWatcher(),
    courseEditWatcher(),
    courseUpdateWatcher(),
    courseDeleteWatcher(),
    coursePatchWatcher(),
    courseReportWatcher(),
    courseCardLinkPatchWatcher(),
    courseSettingsCreateWatcher(),
    courseSettingsPatchWatcher(),
    openAiCardRequestWatcher(),
    aiInstructionWatcher(),
    openAiCourseCreationGetTitleRequestWatcher(),
    openAiCourseCreationGetOutlineRequestWatcher(),
    openaiSendCourseCreationRequestWatcher(),
    templateCourseCloneWatcher(),
    sendCreatePromptFromCardContentRequestWatcher(),
    getCourseAnalyticsByIdWatcher(),
    generateQuizzesByCourseIdWatcher(),
    exportCourseToScormWatcher(),
    courseCreationProgressWatcher(),
    sectionPatchWatcher(),
    addSectionWatcher(),
    createCourseWatcher(),
    courseGetByIdWatcher(),
    generateCardWatcher(),
    domainListWatcher(),
    domainDeleteWatcher(),
    domainRetryWatcher(),
    domainPatchWatcher(),
    domainAddWatcher(),
    getCourseLandingPageWatcher(),
    landingPageWatcher(),
    courseFilterWatcher(),

    courseTimeSeriesListWatcher(),
    courseStatisticsListWatcher(),
    courseTimeSeriesReportWatcher(),
    courseStatisticsReportWatcher(),

    appsumoCodeVerifierSagaWatcher(),

    appsumoCodeRefundSagaWatcher(),

    userRoleDetailedListWatcher(),
    setUserRoleWatcher(),

    createCourseCollectionSagaWatcher(),
    deleteCourseCollectionWatcher(),
    patchCourseCollectionWatcher(),
    courseCollectionListWatcher(),
    courseCollectionUpdateWatcher(),
    editCourseCollectionIndexWatcher(),
    courseCloneWatcher(),
    courseCollectionPatchWatcher(),

    getCollectionAnalyticsWatcher(),
    courseCollectionAnalyticsDownloadWatcher(),
    teamsListWatcher(),
    teamAddWatcher(),
    patchTeamWatcher(),
    deleteTeamWatcher(),
    teamsMemberListWatcher(),
    teamsMemberDeleteWatcher(),
    patchTeamMemberWatcher(),
    addTeamsMemberWatcher(),
    teamsMemberExportWatcher(),
    teamsImportMemberWatcher(),
    sendMailToLearnerWatcher(),

    getChatsWatcher(),
    sendChatMessageWatcher(),
    getChatMessagesWatcher(),
    updateChatMessageWatcher(),
    uploadAttachmentWatcher(),
    checkAttachmentStatusWatcher(),
    deleteAttachmentWatcher(),
    finalToolWatcher(),
    getTranslatedChatContentWatcher(),

    createCertificateSagaWatcher(),
    getCertificateSagaWatcher(),
    getCertificateListSagaWatcher(),
    patchCertificateWatcher(),

    aICreatorUpdateOutlineWatcher(),
    aICreatorUploadAttachmentWatcher(),
    aICreatorCheckAttachmentStatusWatcher(),
    aICreatorDeleteAttachmentWatcher(),
    aICreatorGenerateOutlineWatcher(),
    aICreatorGenerateCourseWatcher(),
    aICreatorGetRecentAttachmentsWatcher(),
    getDocumentHeadersWatcher(),
    getAttachmentTitlesWatcher(),

    collectionListWatcher(),
    createCollectionWatcher(),
    getCollectionWatcher(),
    deleteCollectionWatcher(),
    getCollectionCourseListWatcher(),
    getCollectionSettingsWatcher(),
    patchCollectionSettingWatcher(),

    getCollectionLandingPageWatcher(),
    landingPageCollectionWatcher(),
    collectionMemberFilterWatcher(),
  ])
}
